import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import PDPAddToBagSection from 'components/consumer/PDP/PDPAddToBagSection';
import Placeholder from 'components/consumer/Placeholder';
import PDPGalleryLabelsAndViewingCount from 'components/consumer/PDP/PDPGalleryLabelsAndViewingCount';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPRatingsSection from './PDPRatingsSection';
import PDPPriceAndFinance from './PDPPriceAndFinance';
import usePdpSlug from '../state/context/usePdpSlug';
const PDPNameSectionUI = t0 => {
  const $ = _c(29);
  const {
    isEditOrder: t1,
    loading,
    name,
    pdpIsModularBYOProduct: t2,
    subtitle
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const location = useLocation();
  const pdpSlug = usePdpSlug();
  const nameFromRouterState = location?.state?.name;
  const isNameLoading = loading && !nameFromRouterState;
  const nameToDisplay = loading ? nameFromRouterState : name;
  let t3;
  if ($[0] !== isNameLoading || $[1] !== nameToDisplay) {
    t3 = isNameLoading ? <Placeholder type="rect" loading={true} className="!w-full lg:!w-[310px]" style={{
      height: "23px"
    }} /> : nameToDisplay;
    $[0] = isNameLoading;
    $[1] = nameToDisplay;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10">{t3}</h1>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MobileAndTabletOnly><div className="flex flex-row items-center lg:hidden"><PDPGalleryLabelsAndViewingCount /></div></MobileAndTabletOnly>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="flex flex-row items-center">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== subtitle) {
    t7 = subtitle && <div className="pb-1.5 pl-5 md:pl-8 lg:pl-0.5"><span className="text-sm">{subtitle}</span></div>;
    $[8] = subtitle;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== pdpIsModularBYOProduct || $[11] !== pdpSlug) {
    t8 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><PDPRatingsSection key={pdpSlug} pdpIsModularBYOProduct={pdpIsModularBYOProduct} /></div>;
    $[10] = pdpIsModularBYOProduct;
    $[11] = pdpSlug;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isEditOrder || $[14] !== loading || $[15] !== pdpIsModularBYOProduct || $[16] !== pdpSlug) {
    t9 = <PDPPriceAndFinance isEditOrder={isEditOrder} key={pdpSlug} loading={loading} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[13] = isEditOrder;
    $[14] = loading;
    $[15] = pdpIsModularBYOProduct;
    $[16] = pdpSlug;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isEditOrder || $[19] !== loading) {
    t10 = !isEditOrder && <DesktopOnly><div className="ml-2 max-[1023px]:hidden"><PDPAddToBagSection stickyDesktopButtonOnly={true} pageLoading={loading} /></div></DesktopOnly>;
    $[18] = isEditOrder;
    $[19] = loading;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="bg-white pt-4 px-0 pb-3 sticky top-0 z-[999] lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t12 = <>{t6}{t7}{t8}{t11}</>;
    $[24] = t11;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
PDPNameSectionUI.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  subtitle: PropTypes.string
};
export default PDPNameSectionUI;